import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route as RouterRoute, Redirect, withRouter } from 'react-router-dom';
import { NotAuthorizedError } from '../errors';
import OnRoute from './OnRoute';

import Auth from '../libs/Auth';

class Route extends Component {

  componentWillMount() {
    this.authorize(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.authorize(nextProps);
  }

  authorize(props) {
    this.auth = true;
    const { dispatch, component } = props;

    const authorize = props.authorize || component.authorize;

    if (authorize) {
      if (!Auth.isAuthorized({ permission: authorize })) {
        this.auth = false;
        if (dispatch) {
          dispatch({
            type: 'AUTH_ERROR',
            payload: new NotAuthorizedError(),
            error: true,
            meta: {
              permission: authorize
            }
          });
        }
      }
    }
  }


  onRoute(payload) {
    const { dispatch, page, component } = this.props;

    // this has more accurate match values but can be fired more then once if using nested routes with the custom Route component
    dispatch({
      type: 'ROUTE_MATCH',
      payload: {
        ...payload,
        page
      }
    });

    if (component.onRoute) {
      component.onRoute({ ...this.props, dispatch });
    }
  }

  render() {
    const { exact, path, strict, location } = this.props;
    const Layout = this.props.layout;
    const MatchedComponent = this.props.component;

    if (!this.auth) {
      const currentUrl = location.pathname + location.search + location.hash;
      return <Redirect to={`/login?error=NotAuthorizedError&redirectUrl=${encodeURIComponent(currentUrl)}`}/>;
    }

    return (
      <RouterRoute exact={exact} path={path} strict={strict} render={(props) => {
        return <OnRoute onRoute={(payload)=>this.onRoute(payload)}>
          {Layout ?
            <Layout {...props}>
              <MatchedComponent {...props}/>
            </Layout>
            :
            <MatchedComponent {...props}/>
          }
        </OnRoute>

      }}/>
    );
  }
}

const ConnectedRoute = withRouter(connect()(Route));

export const PublicRoute = (props)=><ConnectedRoute {...props} authorize={false} />;
export const PrivateRoute = (props)=><ConnectedRoute {...props} authorize={props.authorize || true} />;

export default ConnectedRoute;



// WEBPACK FOOTER //
// ./src/app/components/Route.js